module.exports = __webpack_public_path__ + "assets/f8d5f9322ae8d43e43d1c55aa4dec40a.png";